module.exports = __webpack_public_path__ + "images/feature/20170228-2-a20c4ea1f9406f37fef22f5459e702c7.jpg";